
import styles from "./MusicLayout.module.css";
import NavigationPanel from "../Utils/NavigationPanel";
import Corcovado from "./Corcovado.jsx";
import Valentine from "./Valentine.jsx";
import April from "./April.jsx";
import TambourineMan from "./TambourineMan.jsx";
import Mornings from "./Mornings.jsx";
import ProjectCard from "../PageLayout/ProjectCard.jsx";
import JumpCode from "../Utils/JumpCode.jsx";
import { useMediaQuery } from "react-responsive";
import InfoPopup from "../Utils/InfoPopup.jsx";

export default function MusicLayout ({active, sections}) {

    const music = ["Corcovado", "My Funny Valentine", "April Come She Will", "Mr Tambourine Man", "One Too Many Mornings"];
    
    const isMobile = useMediaQuery({maxWidth: 599});


    return ( 

        <div id="Music-Projects">
            <div className={styles.projectsHeader}>
                <h1 className={styles.title}>MUsic</h1>
                <div className={styles.jumpButton}> 
                    <InfoPopup alighRight={true} info="Jump to coding projects.">
                        <JumpCode />
                    </InfoPopup>
                </div>
            </div>
            
            <ProjectCard>
                <p>
                    Here are some of my music projects! 
                </p>   

                <p>
                    I love playing jazz, folk, and blues guitar (and occasionally singing) and I feel very lucky to have some amazingly talented friends who are up for making music videos with me. They’re so much fun to produce!
                </p>

                <p>
                    Find me on YouTube at <a href="https://www.youtube.com/channel/UC4WgziWOuAtRZ-2rODL4Zsg" target="_blank" rel="norefferrer noopener" >Janmakingmusic</a>.
                </p>

            </ProjectCard>

            <br />

            <div className={styles.musicContent}>

                { !isMobile && <div> <NavigationPanel active={active} projects={music} /> </div> }
                
                <div>
                    
                    <div ref={sections[6].ref} id="Corcovado">
                        <Corcovado />
                    </div>

                    <div ref={sections[7].ref} id="My Funny Valentine">
                        <Valentine />
                    </div>

                    <div ref={sections[8].ref} id="April Come She Will">
                        <April />
                    </div>

                    <div ref={sections[9].ref} id="Mr Tambourine Man">
                        <TambourineMan />
                    </div>

                    <div ref={sections[10].ref} id="One Too Many Mornings">
                        <Mornings />
                    </div>

                </div>

            </div>
        </div>
    )
}